var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentLoader',{attrs:{"viewBox":"0 0 343 72","speed":2,"primaryColor":"#f2f2f2","secondaryColor":"#e5e5e5"}},[_c('rect',{attrs:{"x":"0","y":"0","rx":"8","ry":"8","width":"343","height":"72"}})])}
var staticRenderFns = []

export { render, staticRenderFns }